<template>
  <section class="px-4 py-12 md:py-20">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center gap-4">
      <h2 class="mb-0">{{ t('landing.cta.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl mt-0">
        {{ t('landing.cta.text') }}
      </p>

      <PodcastSearchForm
        :loading="loading"
        :submit-label="t('landing.cta.submit')"
        @search="emit('search', $event)"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import PodcastSearchForm from '@/components/podcasts/PodcastSearchForm.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'search', term: string): void
}>()

const { t } = useI18n()
</script>
